import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[appElipses]'
})
export class ElipsesDirective {
    // @Input() text: string;

    constructor(private el: ElementRef) {
        // el.nativeElement.style.backgroundColor = 'orange';

        var myTag = el.nativeElement.text;
        if (myTag.length > 100) {
            var truncated = myTag.trim().substring(0, 100).split(" ").slice(0, -1).join(" ") + "…";
            el.nativeElement.text = myTag;
        }
    }

    // @HostListener('mouseenter') onMouseEnter() {
    //     this.hiliteColor(this.customHower);
    // }

    // @HostListener('mouseleave') onMouseLeave() {
    //     this.hiliteColor('yellow');
    // }

    // public hiliteColor(color) {
    //     this.el.nativeElement.style.backgroundColor = color;
    // }
}



// WEBPACK FOOTER //
// ./public/app/_directives/elipses.directive.ts